import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import cultureImage from "../assets/Life.jpg";
import careImage from "../assets/care-image.png";
import Logoimg from "../assets/ev-voice-logo.png";
import teamImage from "../assets/ev91-team.jpg"

const LifeVoice = () => {

  // const jobs = [
  //   {
  //     title: 'Assistant Manager - Finance',
  //     location: 'Bangalore',
  //     aboutUs: 'At VOICE, we are revolutionizing the logistics industry with our innovative electric vehicle (EV) solutions. Our mission is to provide sustainable, efficient, and eco-friendly logistics services that contribute to a greener future.',
  //     jobSummary: 'We are seeking a dynamic and detail-oriented Assistant Manager - Finance to join our team. The successful candidate will play a crucial role in managing financial operations, ensuring accuracy, and providing insights that drive our business forward. If you are passionate about finance and sustainability, and thrive in a fast-paced startup environment, we would love to hear from you.',
  //     responsibilities: [
  //       'Financial Planning & Analysis: Assist in the preparation of financial forecasts, budgets, and financial reports. Analyze financial data to support strategic decision-making.',
  //       'Accounting & Compliance: Oversee daily accounting operations including accounts payable/receivable, general ledger entries, and bank reconciliations. Ensure compliance with financial regulations and standards.',
  //       'Cash Flow Management: Monitor cash flow to ensure sufficient liquidity for operational needs. Develop strategies to optimize cash management.',
  //       'Financial Reporting: Prepare and present regular financial reports to senior management. Assist in the preparation of financial statements and reports for stakeholders.',
  //       'Cost Management: Analyze and manage costs to ensure efficient operations. Identify cost-saving opportunities and implement cost control measures.',
  //       'Audit & Controls: Coordinate with external auditors and manage internal controls to ensure accuracy and compliance with financial policies.',
  //       'Team Collaboration: Work closely with other departments to support financial planning and reporting needs. Provide financial insights and recommendations to support business initiatives.'
  //     ],
  //     experience: [
  //       'Educational Background: Bachelor’s degree in Finance, Accounting, Business Administration, or a related field. Professional certification (e.g., CPA, CFA) is a plus.',
  //       'Experience: Minimum of 3-5 years of experience in finance or accounting roles, with a focus on financial planning and analysis, accounting, and reporting.',
  //       'Industry Knowledge: Experience in the logistics or EV sector is advantageous but not required. Familiarity with startup environments and fast-paced financial operations is preferred.',
  //       'Skills: Strong analytical and problem-solving skills. Proficiency in financial software and Microsoft Excel. Excellent attention to detail and accuracy. Effective communication and interpersonal skills.'
  //     ],
  //     perks: [
  //       'Competitive Salary: Attractive salary package based on experience and qualifications.',
  //       'Health Benefits: Comprehensive health insurance plans, including medical, dental, and vision coverage.',
  //       'Flexible Working Hours: Option for flexible working hours and remote work arrangements.',
  //       'Professional Development: Opportunities for career growth and development through training and mentorship programs.',
  //       'Innovative Environment: Work in a cutting-edge EV-based logistics startup with a focus on sustainability and innovation.',
  //       'Team Culture: Collaborative and supportive work culture with team-building activities and a focus on employee well-being.'
  //     ]
  //   },
  //   {
  //     title: 'Assistant Manager EV - Rider Sourcing',
  //     location: 'Bangalore',
  //     aboutUs: 'At VOICE, we are revolutionizing the logistics industry with our innovative electric vehicle (EV) solutions. Our mission is to provide sustainable, efficient, and eco-friendly logistics services that contribute to a greener future.',
  //     jobSummary: 'We are looking for an enthusiastic and experienced Assistant Manager - EV Rider Sourcing to join our team. The ideal candidate will be responsible for sourcing and managing a network of EV riders to ensure efficient and reliable delivery services. This role requires a strategic thinker with strong negotiation skills and a passion for enhancing operational efficiency.',
  //     responsibilities: [
  //       'Rider Sourcing: Develop and execute strategies for sourcing and recruiting EV riders. Identify and engage potential riders through various channels including job boards, social media, and local networks.',
  //       'Recruitment & Onboarding: Oversee the recruitment process, including screening, interviewing, and onboarding new riders. Ensure a smooth integration into the company’s operations and culture.',
  //       'Performance Management: Monitor and evaluate rider performance, providing feedback and implementing improvement plans as needed. Address any performance issues promptly.',
  //       'Relationship Building: Build and maintain strong relationships with riders, addressing their concerns and ensuring high levels of satisfaction. Foster a positive and motivated riding community.',
  //       'Operational Coordination: Collaborate with other departments to align rider sourcing strategies with operational needs. Ensure that rider availability meets demand and operational requirements.',
  //       'Compliance & Training: Ensure riders comply with company policies, safety standards, and legal regulations. Organize and deliver training programs to enhance rider skills and knowledge.',
  //       'Data Analysis: Track and analyze key metrics related to rider performance and sourcing effectiveness. Use data to drive improvements and optimize sourcing strategies.',
  //       'Cost Management: Manage budgets related to rider recruitment and sourcing. Identify cost-effective solutions and negotiate terms with external partners when applicable.'
  //     ],
  //     experience: [
  //       'Educational Background: Bachelor’s degree in Business Administration, Human Resources, Logistics, or a related field.',
  //       'Experience: Minimum of 3-5 years of experience in rider or driver recruitment, logistics management, or a related role. Experience in the EV or transportation sector is a plus.',
  //       'Skills: Strong interpersonal and communication skills. Proven ability to negotiate and build relationships. Excellent organizational and problem-solving abilities. Proficiency in Microsoft Office and experience with recruitment software or applicant tracking systems.',
  //       'Knowledge: Familiarity with rider compliance requirements, safety regulations, and best practices in logistics.'
  //     ],
  //     perks: [
  //       'Competitive Salary: Attractive salary package based on experience and qualifications.',
  //       'Health Benefits: Comprehensive health insurance plans, including medical, dental, and vision coverage.',
  //       'Flexible Working Hours: Option for flexible working hours and remote work arrangements.',
  //       'Professional Development: Opportunities for career growth and development through training and mentorship programs.',
  //       'Innovative Environment: Work in a cutting-edge EV-based logistics startup with a focus on sustainability and innovation.',
  //       'Team Culture: Collaborative and supportive work culture with team-building activities and a focus on employee well-being.'
  //     ]
  //   },
  //   // {
  //   //   title: 'Content Writer',
  //   //   location: 'Bangalore',
  //   //   aboutUs: 'At VOICE, we are revolutionizing the logistics industry with our innovative electric vehicle (EV) solutions. Our mission is to provide sustainable, efficient, and eco-friendly logistics services that contribute to a greener future.',
  //   //   jobSummary: 'We are seeking a talented and creative Content Writer to join our team. The ideal candidate will have a passion for writing and a knack for crafting engaging and persuasive content. This role involves producing high-quality content for various platforms, including websites, blogs, social media, and marketing materials.',
  //   //   responsibilities: [
  //   //     'Content Creation: Write clear, compelling, and original content for various formats including web pages, blog posts, articles, social media updates, email campaigns, and marketing collateral.',
  //   //     'Research: Conduct thorough research on industry-related topics to ensure content accuracy and relevance. Stay updated with industry trends and audience preferences.',
  //   //     'SEO Optimization: Implement SEO best practices in content creation to improve search engine rankings and drive organic traffic.',
  //   //     'Editing & Proofreading: Review and edit content for grammar, punctuation, style, and consistency. Ensure all content is polished and aligns with brand guidelines.',
  //   //     'Content Strategy: Collaborate with the marketing team to develop content strategies that align with business objectives and target audience needs.',
  //   //     'Content Management: Manage and organize content using content management systems (CMS) and ensure timely publishing of content.',
  //   //     'Feedback & Revisions: Incorporate feedback from stakeholders and make necessary revisions to content as required.'
  //   //   ],
  //   //   experience: [
  //   //     'Educational Background: Bachelor’s degree in English, Journalism, Communications, Marketing, or a related field.',
  //   //     'Experience: Minimum of 2-4 years of experience in content writing or a related role. Experience in [specific industry or type of content, e.g., tech, finance, lifestyle] is a plus.',
  //   //     'Skills: Exceptional writing, editing, and proofreading skills. Strong command of grammar and style. Ability to write in different tones and styles based on audience and platform. Proficiency in SEO and familiarity with content management systems (CMS) like WordPress.',
  //   //     'Portfolio: Proven track record of writing high-quality content. A portfolio showcasing previous work is required.'
  //   //   ],
  //   //   perks: [
  //   //     'Competitive Salary: Attractive salary package based on experience and qualifications.',
  //   //     'Health Benefits: Comprehensive health insurance plans, including medical, dental, and vision coverage.',
  //   //     'Flexible Working Hours: Option for flexible working hours and remote work arrangements.',
  //   //     'Professional Development: Opportunities for career growth and development through training and mentorship programs.',
  //   //     'Innovative Environment: Work in a cutting-edge EV-based logistics startup with a focus on sustainability and innovation.',
  //   //     'Team Culture: Collaborative and supportive work culture with team-building activities and a focus on employee well-being.'
  //   //   ]
  //   // },
  //   // {
  //   //   title: 'Digital Marketing Associate',
  //   //   location: 'Bangalore',
  //   //   aboutUs: 'At VOICE, we are revolutionizing the logistics industry with our innovative electric vehicle (EV) solutions. Our mission is to provide sustainable, efficient, and eco-friendly logistics services that contribute to a greener future.',
  //   //   jobSummary: 'We are looking for a motivated and detail-oriented Digital Marketing Associate to support our digital marketing efforts. The ideal candidate will have a strong understanding of digital marketing channels and tactics, with a passion for optimizing campaigns and driving results. This role involves assisting with the development, execution, and analysis of digital marketing campaigns.',
  //   //   responsibilities: [
  //   //     'Campaign Management: Assist in the planning, execution, and management of digital marketing campaigns across various channels including social media, email, search engines, and display advertising.',
  //   //     'Content Creation: Collaborate with the content team to create engaging and relevant content for digital platforms, including social media posts, blog articles, and email newsletters.',
  //   //     'Analytics & Reporting: Monitor and analyze campaign performance using tools like Google Analytics, social media insights, and other analytics platforms. Prepare regular reports on key performance metrics and make data-driven recommendations.',
  //   //     'SEO & SEM: Support SEO strategies to improve website rankings and drive organic traffic. Assist with paid search campaigns (PPC) to optimize ad performance and budget allocation.',
  //   //     'Social Media Management: Manage and schedule social media posts, engage with followers, and monitor social media trends and feedback.',
  //   //     'Email Marketing: Assist in the creation and execution of email marketing campaigns, including segmentation, personalization, and A/B testing.',
  //   //     'Market Research: Conduct research on industry trends, competitor activities, and consumer behavior to inform marketing strategies and tactics.'
  //   //   ],
  //   //   experience: [
  //   //     'Educational Background: Educational Background: Bachelor’s degree in Marketing, Business, Communications, or a related field.',
  //   //     'Experience: Experience: 1-3 years of experience in digital marketing or a related role. Familiarity with digital marketing tools and platforms is preferred.',
  //   //     'Skills: Strong understanding of digital marketing channels, including social media, SEO, SEM, and email marketing. Proficiency in using analytics tools such as Google Analytics. Excellent written and verbal communication skills. Ability to work collaboratively in a team environment and manage multiple tasks simultaneously.',
  //   //     'Technical Skills: Basic knowledge of HTML/CSS, experience with CMS platforms (e.g., WordPress), and familiarity with design tools (e.g., Canva) is a plus.'
  //   //   ],
  //   //   perks: [
  //   //     'Competitive Salary: Attractive salary package based on experience and qualifications.',
  //   //     'Health Benefits: Comprehensive health insurance plans, including medical, dental, and vision coverage.',
  //   //     'Flexible Working Hours: Option for flexible working hours and remote work arrangements.',
  //   //     'Professional Development: Opportunities for career growth and development through training and mentorship programs.',
  //   //     'Innovative Environment: Work in a cutting-edge EV-based logistics startup with a focus on sustainability and innovation.',
  //   //     'Team Culture: Collaborative and supportive work culture with team-building activities and a focus on employee well-being.'
  //   //   ]
  //   // },
  //   {
  //     title: 'Field Recruiter',
  //     location: 'Bangalore',
  //     aboutUs: 'At VOICE, we are revolutionizing the logistics industry with our innovative electric vehicle (EV) solutions. Our mission is to provide sustainable, efficient, and eco-friendly logistics services that contribute to a greener future.',
  //     jobSummary: 'The Field Recruiter will play a crucial role in sourcing and recruiting qualified EV riders for our logistics operations. This role involves field-based recruitment activities, engaging with potential candidates, and managing the recruitment process to ensure we attract and hire the best talent to support our growth in the EV sector.',
  //     responsibilities: [
  //       'Talent Sourcing: Actively source and identify potential EV riders through various channels including job fairs, community outreach, and direct engagement.',
  //       'Candidate Engagement: Conduct outreach to potential candidates, explain job roles, and assess their fit for the EV rider positions.',
  //       'Field Recruitment Activities: Organize and participate in recruitment events, job fairs, and community programs focused on sourcing EV riders.',
  //       'Screening and Interviews: Perform initial candidate screenings, schedule interviews, and conduct assessments to evaluate suitability for EV rider roles.',
  //       'Coordination: Collaborate with hiring managers to understand specific requirements and ensure a smooth recruitment process.',
  //       'Relationship Building: Develop strong relationships with candidates and local communities to build a robust talent pipeline.',
  //       'Market Analysis: Stay informed about trends in the EV industry and labor market to enhance recruitment strategies.',
  //       'Reporting: Maintain accurate records of recruitment activities, candidate interactions, and metrics. Prepare regular reports for management.',
  //       'Compliance: Ensure all recruitment activities adhere to legal requirements and company policies.',
  //     ],
  //     experience: [
  //       'Educational Background: Bachelor’s degree in Human Resources, Business Administration, or a related field preferred.',
  //       'Experience: 2-4 years of experience in recruitment, with a focus on field-based recruitment or sourcing roles.',
  //       'Skills: Strong understanding of recruitment strategies and sourcing techniques, particularly in the logistics or transportation sector.',
  //       'Technical Skills: Proficiency in using applicant tracking systems (ATS) and recruitment software. Familiarity with social media platforms for recruitment.',
  //       'Soft Skills: Excellent communication, interpersonal, and organizational skills. Ability to engage with diverse candidates and manage multiple recruitment tasks.',
  //       'Industry Knowledge: Knowledge of the EV industry and an understanding of the specific requirements for EV rider roles is highly desirable.'
  //     ],
  //     perks: [
  //       'Competitive Salary: Attractive salary package based on experience and qualifications.',
  //       'Health Benefits: Comprehensive health insurance plans, including medical, dental, and vision coverage.',
  //       'Flexible Working Hours: Option for flexible working hours and remote work arrangements.',
  //       'Professional Development: Opportunities for career growth and development through training and mentorship programs.',
  //       'Innovative Environment: Work in a cutting-edge EV-based logistics startup with a focus on sustainability and innovation.',
  //       'Team Culture: Collaborative and supportive work culture with team-building activities and a focus on employee well-being.'
  //     ]
  //   },
  //   {
  //     title: 'Senior MIS Specialist',
  //     location: 'Bangalore',
  //     aboutUs: 'At VOICE, we are revolutionizing the logistics industry with our innovative electric vehicle (EV) solutions. Our mission is to provide sustainable, efficient, and eco-friendly logistics services that contribute to a greener future.',
  //     jobSummary: 'The Senior MIS Specialist will be responsible for overseeing the management information systems (MIS) within the organization, ensuring that data is accurately collected, analyzed, and presented to support strategic decision-making. This role involves managing and improving MIS processes, developing reports and dashboards, and collaborating with various departments to meet their information needs.',
  //     responsibilities: [
  //       'MIS Management: Oversee the design, development, and implementation of MIS solutions to meet organizational needs. Ensure data integrity and accuracy across all systems.',
  //       'Reporting and Analysis: Create, analyze, and present comprehensive reports and dashboards that support business decisions. Utilize data visualization tools to effectively communicate insights.',
  //       'System Optimization: Identify areas for improvement within existing MIS processes and implement solutions to enhance system performance and efficiency.',
  //       'Data Management: Ensure proper data collection, validation, and storage procedures. Maintain data security and confidentiality standards.',
  //       'Collaboration: Work closely with various departments to understand their reporting needs and provide tailored solutions. Act as a liaison between technical teams and end-users.',
  //       'Project Management: Lead and manage MIS projects from inception to completion. Coordinate with stakeholders to ensure project goals are met within deadlines and budgets.',
  //       'Technical Support: Provide technical support and training to users on MIS tools and systems. Troubleshoot and resolve system issues as they arise.',
  //       'Documentation: Maintain comprehensive documentation of MIS processes, procedures, and system configurations.'
  //     ],
  //     experience: [
  //       'Educational Background: Bachelor’s degree in Information Systems, Computer Science, Business Administration, or a related field. A Master’s degree or relevant certifications (e.g., PMP, CBIP) is a plus.',
  //       'Experience: 5+ years of experience in MIS or related roles, with a strong background in managing information systems and data analysis.',
  //       'Technical Skills: Proficiency in MIS tools, databases, and reporting software (e.g., SQL, Excel, BI tools like Power BI, Tableau). Experience with ERP systems is an advantage.',
  //       'Analytical Skills: Strong analytical and problem-solving skills with the ability to interpret complex data and provide actionable insights.',
  //       'Project Management: Experience in managing projects, including planning, execution, and delivery.',
  //       'Communication Skills: Excellent verbal and written communication skills. Ability to present data and findings to both technical and non-technical stakeholders.',
  //       'Attention to Detail: Strong attention to detail and commitment to maintaining data accuracy and integrity.'
  //     ],
  //     perks: [
  //       'Competitive Salary: Attractive salary package based on experience and qualifications.',
  //       'Health Benefits: Comprehensive health insurance plans, including medical, dental, and vision coverage.',
  //       'Flexible Working Hours: Option for flexible working hours and remote work arrangements.',
  //       'Professional Development: Opportunities for career growth and development through training and mentorship programs.',
  //       'Innovative Environment: Work in a cutting-edge EV-based logistics startup with a focus on sustainability and innovation.',
  //       'Team Culture: Collaborative and supportive work culture with team-building activities and a focus on employee well-being.'
  //     ]
  //   },
  // ];

  const reviews = [
    {
      logo: require("../assets/client-logo2.png"),
      photo: require("../assets/basha-review.jpg"),
      name: "Shaik Jani Basha:",
      text: "EV91 has transformed our logistics with their reliable and eco-friendly solutions. Highly recommended!",
      earnings: "1,00,000-1,20,000",
      city: "Hyderabad",
    },
    {
      logo: require("../assets/client-logo2.png"),
      photo: require("../assets/subash-review.jpg"),
      name: "subhash:",
      text: "The team at VOICE is innovative and always delivers on time. Great experience working with them.",
      earnings: "75000-78000",
      city: "Chennai",
    },
    {
      logo: require("../assets/client-logo6.png"),
      photo: require("../assets/shankar-review.jpg"),
      name: "Shiva Shankar:",
      text: "Professional, sustainable, and efficient. VOICE is the future of logistics.",
      earnings: "65000-75000",
      city: "Chennai",
    },
    {
      logo: require("../assets/client-logo2.png"),
      photo: require("../assets/anbu-review.jpg"),
      name: "Anbu kumar:",
      text: "Excellent service and a wonderful team. We are proud to be associated with VOICE.",
      earnings: "75,000-80,000",
      city: "Chennai",
    },
    {
      logo: require("../assets/client-logo2.png"),
      photo: require("../assets/mohammed-review.jpg"),
      name: "Mohammed Jameel:",
      text: "Great support and innovative solutions. VOICE is a game changer in the EV logistics space.",
      earnings: "85,000-95,000",
      city: "Bengaluru",
    },
    {
      logo: require("../assets/client-logo6.png"),
      photo: require("../assets/mani-review.jpg"),
      name: "Manigandhan S:",
      text: "The team is very responsive and always ready to help. Highly recommend their services.",
      earnings: "1,10,000",
      city: "Chennai",
    },
  ];

  const jobOpenings = [
    {
      title: "Senior MIS Specialist",
      department: "Any Degree",
      type: "Full-Time",
      location: "Bangalore, India",
      experience: "2+ years",
      educationalBackground:
        "Bachelor’s degree in Information Systems, Computer Science, Business Administration, or a related field. A Master’s degree or relevant certifications (e.g., PMP, CBIP) is a plus.",
      experience_required:
        "Experience: 2+ years of experience in MIS or related roles, with a strong background in managing information systems and data analysis.",
      skills:
        "Proficiency in MIS tools, databases, and reporting software (e.g., SQL, Excel, BI tools like Power BI, Tableau). Experience with ERP systems is an advantage.",
      description:
        "The Senior MIS Specialist will be responsible for overseeing the management information systems (MIS) within the organization, ensuring that data is accurately collected, analyzed, and presented to support strategic decision-making.",
    },
    {
      title: "Field Recruiter",
      department: "Any Degree",
      type: "Full-Time",
      location: "Bangalore, India",
      experience: "2+ years",
      educationalBackground: "Any Degree",
      experience_required:
        "2-4 years of experience in recruitment, with a focus on field-based recruitment or sourcing roles.",
      skills:
        "Strong understanding of recruitment strategies and sourcing techniques, particularly in the logistics or transportation sector.",
      description:
        "The Field Recruiter will play a crucial role in sourcing and recruiting qualified EV riders for our logistics operations. This role involves field-based recruitment activities, engaging with potential candidates, and managing the recruitment process to ensure we attract and hire the best talent to support our growth in the EV sector.",
    },
  ];
  const [showAll, setShowAll] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const visibleJobs = showAll ? jobOpenings : jobOpenings.slice(0, 2);

  return (
    <>
      <Helmet>
        <title>Life @ Voice | EV91Technologies</title>
        <meta
          name="description"
          content="Discover the culture, careers, and life at EV91Technologies (VOICE). Join our team and be part of the electric mobility revolution."
        />
        <meta
          name="keywords"
          content="Life at Voice, careers, culture, jobs, EV91, VOICE, electric vehicles"
        />
        <meta property="og:title" content="Life @ Voice | EV91Technologies" />
        <meta
          property="og:description"
          content="Discover the culture, careers, and life at EV91Technologies (VOICE). Join our team and be part of the electric mobility revolution."
        />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ev91riderz.com/life-voice" />
        <link rel="canonical" href="https://ev91riderz.com/life-voice" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Life @ Voice | EV91Technologies",
            "description": "Discover the culture, careers, and life at EV91Technologies (VOICE). Join our team and be part of the electric mobility revolution.",
            "url": "https://ev91riderz.com/life-voice"
          }
        `}</script>
      </Helmet>
      <div>
        <section className="relative -mt-6 overflow-hidden bg-slate-950 px-5 py-20 text-white lg:px-8">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(190,242,100,0.18),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(16,185,129,0.2),transparent_40%)]"></div>
          <div className="relative mx-auto grid max-w-7xl gap-10 lg:grid-cols-[1fr_0.95fr] lg:items-center">
            <div>
              <p className="text-sm font-black uppercase tracking-[0.26em] text-lime-300">Life at VOICE</p>
              <h1 className="mt-4 text-4xl font-black tracking-tight md:text-6xl">
                Work with the team building India’s electric logistics engine.
              </h1>
              <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-300">
                Join a culture built around operations, learning, rider empathy, and measurable city impact.
              </p>
              <a href="#our ryderz" className="mt-8 inline-flex rounded-full bg-lime-300 px-7 py-3 font-black text-slate-950 transition hover:-translate-y-0.5 hover:bg-white">
                Explore culture
              </a>
            </div>
            <div className="relative">
              <img src={teamImage} alt="Life at VOICE" className="h-[380px] w-full rounded-[2rem] object-cover shadow-2xl shadow-black/30" />
              <div className="absolute -bottom-5 left-5 right-5 grid grid-cols-3 gap-3 rounded-[1.5rem] border border-white/10 bg-slate-950/85 p-4 text-center backdrop-blur">
                {["Learning", "Care", "Growth"].map((item) => (
                  <div key={item} className="text-sm font-black text-lime-100">{item}</div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="hidden">
          {/* Blurred Circle Effects */}
          <div className="absolute top-[-80px] left-[-80px] w-72 h-72 bg-green-400 opacity-30 rounded-full blur-3xl animate-pulse" />
          <div className="absolute bottom-[-60px] right-[-60px] w-96 h-96 bg-green-600 opacity-20 rounded-full blur-2xl animate-ping" />

          {/* Content Box */}
          <div className="relative z-10 max-w-5xl mx-auto text-center backdrop-blur-md bg-white/10 rounded-3xl p-2 shadow-xl border border-white/10">
            <h1 className="text-4xl md:text-5xl font-bold text-lime-300 mb-4 tracking-tight">
              👥 Life at Voice
            </h1>
            <p className="text-lg md:text-xl text-gray-200 max-w-3xl mx-auto">
              Experience what it’s like to work at VOICE — a workplace filled
              with collaboration, innovation, and impact. Discover the stories,
              culture, and people behind our mission. 🚀
            </p>
            <a
              href="#our ryderz"
              className="mt-8 inline-block bg-white text-green-800 font-semibold px-6 py-3 rounded-full shadow-md hover:bg-green-100 transition-transform transform hover:scale-105"
            >
              🎬 Explore Life at VOICE
            </a>
          </div>
        </section>

        <section className="py-20 bg-slate-50 text-blue-900">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="mb-12 grid gap-4 md:grid-cols-3">
              {[
                ["Purpose-led", "Work on real EV adoption across Indian cities."],
                ["People-first", "Benefits, learning, mentorship, and rider empathy."],
                ["Fast-moving", "Startup energy with operations discipline."],
              ].map(([title, desc]) => (
                <div key={title} className="group relative overflow-hidden rounded-[2rem] border border-emerald-100 bg-white p-7 shadow-xl shadow-slate-900/8 transition hover:-translate-y-1 hover:shadow-2xl">
                  <div className="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-emerald-500 via-lime-300 to-slate-950"></div>
                  <div className="absolute right-0 top-0 h-24 w-24 rounded-bl-[2rem] bg-slate-950 transition group-hover:bg-emerald-700"></div>
                  <div className="relative mb-5 grid h-12 w-12 place-items-center rounded-2xl bg-lime-100 text-lg font-black text-emerald-900">
                    {title.slice(0, 1)}
                  </div>
                  <h3 className="relative text-xl font-black text-slate-950">{title}</h3>
                  <p className="mt-2 leading-7 text-slate-600">{desc}</p>
                </div>
              ))}
            </div>
            <div className="flex flex-col md:flex-row items-center justify-between gap-10">
              {/* Image Section */}
              <div className="w-full md:w-1/2 relative group">
                <img
                  src={cultureImage}
                  alt="Culture at VOICE"
                  className="w-full h-auto rounded-3xl shadow-2xl transition-transform duration-500 group-hover:scale-105"
                />
                {/* Decorative Glow */}
                <div className="absolute inset-0 rounded-3xl ring-4 ring-green-300/20 blur-lg opacity-0 group-hover:opacity-100 transition duration-700"></div>
              </div>

              {/* Text Section */}
              <div className="w-full md:w-1/2 bg-white border border-emerald-100 p-10 rounded-[2rem] shadow-2xl shadow-slate-900/10 animate-fadeUp">
                <p className="mb-3 text-sm font-black uppercase tracking-[0.22em] text-emerald-700">Culture system</p>
                <h2 className="text-4xl font-extrabold mb-6 text-green-800 text-center md:text-left">
                  🌟 Culture at VOICE
                </h2>

                <p className="text-lg md:text-xl text-gray-800 leading-relaxed mb-4 text-center md:text-left">
                  At <strong className="text-green-900">VOICE</strong>, we
                  cultivate a culture built on
                  <span className="text-green-700 font-medium">
                    {" "}
                    innovation
                  </span>
                  ,<span className="text-green-700 font-medium"> teamwork</span>
                  , and
                  <span className="text-green-700 font-medium">
                    {" "}
                    sustainability
                  </span>
                  . 💡🤝🌱 Our mission-driven team shares a unified vision — to
                  revolutionize logistics with environmentally responsible
                  solutions.
                </p>

                <p className="text-lg md:text-xl text-gray-800 leading-relaxed text-center md:text-left">
                  We foster an atmosphere where 💬{" "}
                  <strong>creativity flourishes</strong>, 🌈{" "}
                  <strong>ideas are respected</strong>, and every individual
                  feels empowered to contribute meaningfully. Join us in
                  creating a brighter, greener future. 🚀
                </p>
              </div>
            </div>
          </div>

          {/* Fade Animation */}
          <style>{`
    @keyframes fadeUp {
      0% {
        opacity: 0;
        transform: translateY(40px);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
    .animate-fadeUp {
      animation: fadeUp 1s ease-out forwards;
    }
  `}</style>
        </section>

        <section
          className="py-20 bg-white overflow-hidden"
          id="care-section"
        >
          <div className="container mx-auto flex flex-col md:flex-row items-center px-6 md:px-0 animate-fade-in">
            {/* Left Image */}
            <div className="md:w-1/2 mb-10 md:mb-0 animate-slide-in-left">
              <img
                src={careImage}
                alt="We Care For You"
                className="w-full h-auto rounded-3xl shadow-2xl object-cover border-4 border-green-200 hover:scale-[1.02] transition-transform duration-500"
              />
            </div>

            {/* Right Content */}
            <div className="md:w-1/2 md:pl-10 animate-slide-in-right">
              <h2 className="text-4xl md:text-5xl font-extrabold mb-10 text-green-800 flex items-center gap-3 drop-shadow-md">
                💚 We Care For You
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                {/* CARD COMPONENT */}
                {[
                  {
                    icon: "🏥",
                    title: "Medical Insurance",
                    desc: "Life, surgery, dental, inpatient, outpatient and more. Because we really care for you.",
                    color: "border-green-500",
                  },
                  {
                    icon: "📚",
                    title: "Community Learning",
                    desc: "Industry-wide meetups, events and conferences. We pay. You learn.",
                    color: "border-blue-500",
                  },
                  {
                    icon: "🌍",
                    title: "Unity in Diversity",
                    desc: "Work with superstars from across India.",
                    color: "border-yellow-400",
                  },
                  {
                    icon: "🧠",
                    title: "Learning & Development",
                    desc: "Not getting a solution? Relax, our in-house experienced mentors are there to guide you.",
                    color: "border-purple-500",
                  },
                ].map(({ icon, title, desc, color }, idx) => (
                  <div
                    key={idx}
                    className={`group relative overflow-hidden rounded-[1.5rem] border border-emerald-100 bg-slate-50 p-6 shadow-lg shadow-slate-900/5 transition hover:-translate-y-1 hover:bg-white hover:shadow-xl ${color}`}
                  >
                    <div className="absolute right-0 top-0 h-16 w-16 rounded-bl-[1.5rem] bg-white transition group-hover:bg-lime-100"></div>
                    <h3 className="text-lg font-semibold text-green-800 mb-2 flex items-center gap-2">
                      <span>{icon}</span> {title}
                    </h3>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      {desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-slate-950 text-white">
          <div className="container mx-auto px-4" id="our ryderz">
            <h2 className="text-4xl sm:text-5xl font-extrabold text-center text-white mb-6">
              🏡 Inside VOICE
            </h2>
            <p className="text-center text-slate-300 text-lg max-w-3xl mx-auto mb-14">
              At VOICE, we don't just work — we grow, celebrate, learn, and
              thrive together. 🌱 Our environment blends purpose with passion,
              making every day meaningful. From inclusive culture to continuous
              learning, we care about the people who power our mission. 💚
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {[
                {
                  icon: "🏥",
                  title: "Comprehensive Healthcare",
                  desc: "From medical to dental to mental wellness — we've got you covered, because you matter.",
                },
                {
                  icon: "📚",
                  title: "Skill-Up Sponsorship",
                  desc: "Attend tech meetups, EV events & industry expos — we cover it, you grow with it.",
                },
                {
                  icon: "🌍",
                  title: "Inclusive Team Culture",
                  desc: "Collaborate with passionate minds from across India with shared values and vision.",
                },

                {
                  icon: "🧠",
                  title: "Growth & Mentorship",
                  desc: "In-house experts, mentors and leadership that guide you through your career journey.",
                },
                {
                  icon: "🎉",
                  title: "Celebrations & Retreats",
                  desc: "Team outings, milestone parties, festive events — because fun fuels our mission too!",
                },
                {
                  icon: "🔋",
                  title: "Work-Life Balance",
                  desc: "Flexible hours, recharge days, and mental wellness breaks to help you stay energized.",
                },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="group relative overflow-hidden rounded-[1.5rem] border border-white/10 bg-white/8 p-6 shadow-xl shadow-black/10 backdrop-blur transition hover:-translate-y-1 hover:bg-white hover:text-slate-950"
                >
                  <div className="w-14 h-14 rounded-2xl bg-lime-300 text-slate-950 flex items-center justify-center mb-4 text-2xl">
                    {item.icon}
                  </div>
                  <h3 className="text-xl font-bold text-lime-200 mb-2 group-hover:text-slate-950">
                    {item.title}
                  </h3>
                  <p className="text-slate-300 text-sm leading-6 group-hover:text-slate-600">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 bg-gradient-to-br from-green-50 via-white to-green-100">
          <style>
            {`
      @keyframes reviewMarquee {
        0% { transform: translateX(0%); }
        100% { transform: translateX(-100%); }
      }
    `}
          </style>

          <div className="container mx-auto px-4" id="our_riders">
            <h2 className="text-4xl font-bold text-center text-green-800 mb-12 drop-shadow-sm">
              💬 What Our Riders Say
            </h2>

            <div className="overflow-hidden w-full">
              <div
                className="flex gap-8 animate-[reviewMarquee_55s_linear_infinite]"
                style={{ width: `${reviews.length * 320}px` }}
              >
                {reviews.map((review, idx) => (
                  <div
                    key={idx}
                    className="w-[320px] bg-white rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 flex-shrink-0 border border-green-100"
                  >
                    {/* Header Strip */}
                    <div className="bg-gradient-to-r from-green-600 to-lime-600 rounded-t-3xl p-3 flex justify-between items-center">
                      <img
                        src={Logoimg}
                        alt="EV Logo"
                        className="h-7 w-auto object-contain"
                      />
                      <img
                        src={review.logo}
                        alt="Client Logo"
                        className="h-7 w-auto object-contain opacity-90"
                      />
                    </div>

                    {/* Content */}
                    <div className="p-6 text-center">
                      {/* Reviewer Photo */}
                      <img
                        src={review.photo}
                        alt={review.name}
                        className="w-20 h-20 object-cover rounded-full mx-auto border-4 border-green-500 shadow-md mb-3"
                      />

                      {/* Name + Stars */}
                      <h3 className="text-lg font-semibold text-green-800">
                        {review.name}
                      </h3>
                      <div className="text-yellow-400 text-base mt-1">
                        {"★".repeat(5)}
                      </div>
                      <p className="text-xs text-green-600 mt-1 font-medium">
                        Total Earnings: {review.earnings || "₹1,00,000+"}
                      </p>

                      {/* Review Text */}
                      <p className="mt-4 text-gray-600 text-sm italic leading-relaxed">
                        “{review.text}”
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Current Openings */}
        <section className="relative overflow-hidden bg-slate-950 px-4 py-20 text-white">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(190,242,100,0.18),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(16,185,129,0.18),transparent_36%)]"></div>
        <div className="relative mx-auto max-w-7xl rounded-[2rem] border border-white/10 bg-white/8 p-6 shadow-2xl shadow-black/20 backdrop-blur md:p-8">
          <div className="text-center mb-8">
            <p className="text-sm font-black uppercase tracking-[0.24em] text-lime-300">
              Careers
            </p>
            <h2 className="mt-3 text-4xl font-black text-center text-white mb-2 md:text-5xl">
              Current Openings at VOICE
            </h2>
            <p className="mx-auto max-w-2xl text-slate-300">
              Join our mission to revolutionize electric mobility in India
            </p>
          </div>

          {/* Job Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {visibleJobs.map((job, index) => (
              <div
                key={index}
                className="group rounded-[1.5rem] border border-white/10 bg-white p-6 text-slate-950 shadow-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-lime-300/20"
              >
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h4 className="text-xl font-bold text-gray-900 mb-2">
                      {job.title}
                    </h4>
                    <div className="flex flex-wrap gap-2 mb-2">
                      <span className="text-xs bg-emerald-50 text-emerald-800 px-3 py-1 rounded-full border border-emerald-100">
                        {job.department}
                      </span>
                      <span className="text-xs bg-slate-100 text-slate-800 px-3 py-1 rounded-full border border-slate-200">
                        {job.type}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <div className="text-sm text-gray-600">
                    <div className="flex items-center mb-1">
                      <span className="w-4 h-4 mr-1 text-green-600">📍</span>
                      {job.location}
                    </div>
                    <div>Experience: {job.experience}</div>
                  </div>
                  <button
                    onClick={() => setSelectedJob(job)}
                    className="rounded-full bg-slate-950 px-5 py-2.5 text-sm font-black text-white transition hover:bg-emerald-700"
                  >
                    Apply Now
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* View All / Show Less */}
          <div className="text-center mt-8">
            <button
              onClick={() => setShowAll(!showAll)}
              className="rounded-full bg-lime-300 px-8 py-3 font-black text-slate-950 transition-all hover:bg-white"
            >
              {showAll ? "Show Less" : "View All Openings"}
            </button>
          </div>

          {/* Modal */}
          {selectedJob && (
            <div className="fixed inset-0 flex items-center justify-center bg-slate-950/70 backdrop-blur-sm z-[70] p-4">
              <div className="bg-white rounded-[2rem] shadow-2xl p-6 w-11/12 md:w-2/3 lg:w-1/2 relative border border-emerald-100">
                <button
                  onClick={() => setSelectedJob(null)}
                  className="absolute top-4 right-4 grid h-10 w-10 place-items-center rounded-full bg-slate-100 text-gray-600 text-xl hover:text-red-500"
                >
                  ✕
                </button>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {selectedJob.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  <strong>Department:</strong> {selectedJob.department} |{" "}
                  <strong>Type:</strong> {selectedJob.type}
                </p>
                <p className="text-gray-700 leading-relaxed mb-6">
                  {selectedJob.description}
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-6">
                  <li>
                    <strong>Educational Background:</strong>{" "}
                    {selectedJob.educationalBackground}
                  </li>
                  <li>
                    <strong>Experience:</strong>{" "}
                    {selectedJob.experience_required}
                  </li>
                  <li>
                    <strong>Technical Skills:</strong> {selectedJob.skills}
                  </li>
                </ul>
                <div className="flex justify-end">
                  <a
                    href="https://forms.gle/66Grv7CagHPmKHAP7"
                    className="rounded-full bg-slate-950 px-6 py-3 font-black text-white hover:bg-emerald-700"
                  >
                    Apply Now
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
        </section>
      </div>
    </>
  );
};

export default LifeVoice;
